import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "quote",
  "use": "quote-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 60 60\" id=\"quote\"><path fill=\"#7257FA\" fill-opacity=\".1\" fill-rule=\"evenodd\" d=\"M23.829 6v10.971c-2.503 0-6.91.208-6.91 10.225V32.4H27.6V54H6V27.196c0-7.875 2.038-13.723 6.49-17.382C15.57 7.284 19.22 6 23.83 6zm26.4 0v10.971c-2.502 0-6.91.208-6.91 10.225V32.4H54V54H32.4V27.196c0-7.875 2.038-13.723 6.49-17.382C41.97 7.284 45.62 6 50.23 6z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol